export default __webpack_public_path__ + "static/media/list.36f04775.svg";